import React, { useState } from 'react'

import { Container } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { ContentHeader, LoadingFeedback, Page } from 'components'

import { CommitteesForm, DialogNewCommitteeRole } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'
import useStyles from './styles'

const CommitteeUsersNew = () => {
  const [openDialogNewCommitteeRole, setOpenDialogNewCommitteeRole] =
    useState(false)
  const [loading, setLoading] = useState(false)
  const params = useParams()

  const classes = useStyles()

  const {
    response: committeeRolesResponse,
    isLoading: isCommitteeRolesLoading,
    refresh: refreshCommitteeRoles,
  } = useFetch(service.dponet.committeeRoles.get, {})

  const committeeRoles = committeeRolesResponse?.data?.committeeRoles

  const {
    response: availableUsersResponse,
    isLoading: isAvailableUsersLoading,
  } = useFetch(service.dponet.committees.availableUsers, {
    committeeId: params.committeeId,
  })

  const availableUsers = availableUsersResponse?.data?.availableUsers

  return (
    <Page title="Novo usuário de comitê">
      <LoadingFeedback
        open={loading || isCommitteeRolesLoading || isAvailableUsersLoading}
      />
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title="Cadastrar novo membro"></ContentHeader>
        <CommitteesForm
          setLoading={setLoading}
          formType="new"
          roles={committeeRoles}
          availableUsers={availableUsers}
          setOpenDialogNewCommitteeRole={setOpenDialogNewCommitteeRole}
        />
      </Container>
      <DialogNewCommitteeRole
        open={openDialogNewCommitteeRole}
        setOpen={setOpenDialogNewCommitteeRole}
        onEvent={refreshCommitteeRoles}
      />
    </Page>
  )
}

export default CommitteeUsersNew
